import React from 'react'
import "./Investments.css";
import ark from "../../assets/icons/investmentsIcons/arkIcon.svg";
import rehla from "../../assets/icons/investmentsIcons/rehlaIcon.svg";
import saudiElan  from "../../assets/icons/investmentsIcons/saudiElanIcon.svg";
import uvera  from "../../assets/icons/investmentsIcons/uveraIcon.svg";
import regard from  "../../assets/icons/investmentsIcons/regardaIcon.svg";
import lead from  "../../assets/icons/investmentsIcons/leadIcon.svg";
import velents from  "../../assets/icons/investmentsIcons/velentsIcon.svg";
import edama from  "../../assets/icons/investmentsIcons/edamaIcon.svg";
import nama from  "../../assets/icons/investmentsIcons/namaIcon.svg";
import wijha from  "../../assets/icons/investmentsIcons/wijhaIcon.svg";
import gbo from  "../../assets/icons/investmentsIcons/gboIcon.svg";
import darcaif from  "../../assets/icons/investmentsIcons/darcaifIcon.svg";
import moneymoon from "../../assets/icons/investmentsIcons/moneymoon.png";
import krti from "../../assets/icons/investmentsIcons/KRTI.png";
import whitefooter from "../../assets/whitefooter.svg";
import hakbah from "../../assets/icons/hakbah.png";
import point2 from "../../assets/whitepoint.svg";
import lawazem from "../../assets/icons/investmentsIcons/lawazem.svg"
import valley from "../../assets/icons/valley.png";
import dit from "../../assets/icons/DIT.png";
import waja from "../../assets/icons/wajarealestate.png";
import arktech from "../../assets/icons/arktech.png";
import jasara2 from "../../assets/icons/jasara logo.png";

import waheedbg from "../../assets/icons/bg.svg";
import { useTranslation } from "react-i18next";

export default function Investments() {
    const { t } = useTranslation();

  return (
    <section id="investments">
      <div
        style={{
          height: "auto",
          background: "#022539",
          paddingBottom: "30px",
        }}
      >
        <div className="title-container">
          <img src={point2} className="bulletPoint" />
          <h1 className="my-investments">{t("my_investments")}</h1>
          <img src={point2} className="bulletPoint" />
        </div>

        {/* <p className="p-content">{t("investment_p")}</p> */}
        <div className="investment-container">
          <img src={waheedbg} alt="bg" className="waheed-bg" />

          <div className="investments-icons">
            <div className="investment-logo">
              <img src={waja} alt="Waja" className="logo-white logo-waja" />
            </div>
            <div className="investment-logo">
              <img src={arktech} alt="Arktech" className="logo-white logo-arktech" />
            </div>
            <div className="investment-logo">
              <img src={dit} alt="DIT" className="logo-white logo-dit" />
            </div>
            <div className="investment-logo">
              <img src={valley} alt="Valley" className="logo-white logo-valley" />
            </div>
            <div className="investment-logo">
              <img src={jasara2} alt="Jasara" className="logo-white logo-jasara" />
            </div>
            <div className="investment-logo">
              <img src={rehla} alt="Rehla" />
            </div>
            <div className="investment-logo">
              <img src={uvera} alt="Uvera" />
            </div>
            <div className="investment-logo">
              <img src={saudiElan} alt="Saudi Elan" />
            </div>
            <div className="investment-logo">
              <img src={regard} alt="Regard" />
            </div>
            <div className="investment-logo">
              <img src={lead} alt="Lead" />
            </div>
            <div className="investment-logo">
              <img src={velents} alt="Velents" />
            </div>
            <div className="investment-logo">
              <img src={edama} alt="Edama" />
            </div>
            <div className="investment-logo">
              <img src={nama} alt="Nama" />
            </div>
            <div className="investment-logo">
              <img src={gbo} alt="GBO" />
            </div>
            <div className="investment-logo">
              <img src={darcaif} alt="Dar Caif" />
            </div>
            <div className="investment-logo">
              <img src={moneymoon} alt="Moneymoon" />
            </div>
            <div className="investment-logo">
              <img src={hakbah} alt="Hakbah" />
            </div>
            <div className="investment-logo">
              <img src={lawazem} alt="Lawazem" />
            </div>
          </div>

          <img src={whitefooter} alt="white-footer" className="white-footer" />
        </div>
        {/* <img src={waheed} alt='waheed-logo' className='waheed-logo'/> */}
      </div>
    </section>
  );
}
